import { createContext } from "react";

const EquipmentOrToolsTypesContext = createContext();

export default EquipmentOrToolsTypesContext